/* js */
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import language from 'element-ui/lib/locale/lang/pt-br'
import locale from 'element-ui/lib/locale'
import Router from './modules/Router'
import VueMask from 'v-mask'
import VMoney from 'v-money'
import VueSwal from 'vue-swal'
import '@/mixins/groupBy'
import '@/assets/js/filters'

/* css */
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '@/assets/css/app.css'

/* vue import plugins  */
Vue.use(ElementUI)
Vue.use(VueMask)
Vue.use(VueSwal)
Vue.use(VMoney, { decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2, masked: false })
locale.use(language)
// Vue.use(VueFreshchat, { appToken: '1ff53564-c67b-4859-aeff-bd96a84b0af2', host: 'https://truckme.freshchat.com', config: {} })

/* vue configs */
Vue.config.productionTip = false

/* default bus implematation */
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $bus: {
    get: function() {
      return EventBus
    }
  }
})

/* eslint-disable no-new */
new Vue({ el: '#app', router: Router, render: (h) => h(App) }) // NOSONAR



// WEBPACK FOOTER //
// ./src/main.js